import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

// 상태정보 - 구성정보
const CfgInfo = ({
                   propType = "repeater",
                   propName = "중계기",
                   propInfo
                 }) => {
  return (
      <>
        <h6 className={"info-container-title text-center mt-3"}>{propName} 구성 정보</h6>
        <div className={'content-container-body-item'}>
          <Form
              className={'equipment-form py-3'}
              id={'equipmentForm'}
          >
            <Row className={"justify-content-center"}>
              <Col md={12}>
                <Row>
                  <Col md={12}>
                    <Form.Group as={Row} controlId="formFcltyNm">
                      <Form.Label column md={4} className={'label text-end'}>
                        시설명
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.fclty_nm || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFloor'>
                      <Form.Label column md={4} className={'label text-end'}>
                        층수
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.fclty_dtl_nm || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formEqmTy'>
                      <Form.Label column md={4} className={'label text-end'}>
                        장비유형
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.device_ty_nm || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        장비ID
                      </Form.Label>
                      <Col md={8}>
                        {propType === 'repeater' ?
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.rpeat_id || ''}
                        /> :
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.sensor_id || ''}
                        />
                        }
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='forml2IpAddr'>
                      <Form.Label column md={4} className={'label text-end'}>
                        장비제조사
                      </Form.Label>
                      <Col md={8}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.mkr || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label  text-end'}>
                        장비모델명
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.modl || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                  {propType !== "repeater" ?
                      <Col md={12}>
                        <Form.Group as={Row} controlId='formFcltyNm'>
                          <Form.Label column md={4} className={'label  text-end'}>
                            중계기명
                          </Form.Label>
                          <Col md={8} className={''}>
                            <Form.Control
                                type='text'
                                className={'input text-white'}
                                disabled={true}
                                defaultValue={propInfo.rpeat_lc_nm || ''}
                            />
                          </Col>
                        </Form.Group>
                      </Col> : ''}

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        장비명(위치)
                      </Form.Label>
                      <Col md={8} className={''}>
                        {propType === 'repeater' ?
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.fclty_lc_nm || ''}
                        /> :
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.sensor_lc_nm || ''}
                        />
                        }
                      </Col>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group as={Row} controlId='formFcltyNm'>
                      <Form.Label column md={4} className={'label text-end'}>
                        설치일자
                      </Form.Label>
                      <Col md={8} className={''}>
                        <Form.Control
                            type='text'
                            className={'input text-white'}
                            disabled={true}
                            defaultValue={propInfo.instl_de || ''}
                        />
                      </Col>
                    </Form.Group>
                  </Col>

                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </>
  );
};

export default CfgInfo;
